import { Plane } from '@react-three/drei';
import { ComponentProps, FunctionComponent } from 'react';
import { NormalBlending } from 'three';

type Props = {
    width: number;
    height: number;
    center?: boolean;
} & ComponentProps<typeof Plane>;

export const ClickTarget: FunctionComponent<Props> = ({ width, height, center = false, children, ...props }) => (
    <Plane position={[center ? width / 2 : 0, 0, 0]} args={[width, height]} {...props}>
        <group position={[center ? -width / 2 : 0, 0, 0]}>{children}</group>
        <meshBasicMaterial
            transparent
            opacity={0.0}
            alphaTest={1.0}
            color={0xff0000}
            blending={NormalBlending}
            clipIntersection={true}
            colorWrite={false}
            depthWrite={false}
            stencilWrite={false}
            toneMapped={false}
            precision={'highp'}
        />
    </Plane>
);
